/* import __COLOCATED_TEMPLATE__ from './add-tag-to-conversation-operation.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import type { NodeSelection } from 'prosemirror-state';
import type CommandsResolver from 'embercom/lib/workflows/commands-resolver';

interface Args {
  commandsResolver: CommandsResolver;
  onUpdateNode: (state: Record<string, unknown>, selection?: NodeSelection) => void;
  closePopover: () => void;
}

export default class AddTagToConversationOperation extends Component<Args> {
  @action
  onUpdateNode(identifier: string): void {
    this.args.onUpdateNode({
      subjectIdentifier: identifier,
      attributeValueType: 'fin',
    });

    this.args.closePopover();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::FinCustom::AiPromptDataPopover::AddTagToConversationOperation': typeof AddTagToConversationOperation;
  }
}
